import baseAPI from "../app/baseAPI";

export const signupReducer = baseAPI.injectEndpoints({
    endpoints(builder) {
        return {
         
            signupResponse: builder.mutation({
            query(params) {
                console.log('prams',params)
              return {
                url: `/user/signup`,
                method: "POST",
                prefixUrlType:"Profile",
            
                body: {
                  ...params.paramsData,
                },
              };
            },
            keepUnusedDataFor: 5,
            transformResponse: (responseData) => responseData,
          }),
        
        };
      },
    });
export const {
  useSignupResponseMutation,

} = signupReducer;
